import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router";
import "./poll_and_survey.css";
import api from "../../../config/api";
import config from "../../../config/config";
import { getCurrentLoggedInSessionToken } from "../../../config/userPool";
import { Dialog } from "@progress/kendo-react-dialogs";
import moment from "moment";
import {
  createAndUpdatePollSurvey,
  fetcheSurveyDetail,
  fetcheSurveyDetailByDepartment,
  fetcheSurveyDetailBySummary,
  fetchSurveyExport,
  fetchSurveyAudit,
  updatePollSurveyStatus
} from "../../../store/poll_and_survey";
import { useDispatch, useSelector } from "react-redux";
import { POLL_SURVEY_ADD, POLL_SURVEY_DETAIL, POLL_SURVEY_LIST } from "../../../routes";
import { AddSurveyHeader } from "./add_header";
import { AddSurveySteps } from "./add_steps";
import { AddPollSurveySteps } from "./add_steps";
import { Notification_Details } from "./view/notification";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import NextIcon from "../../../assets/communication/NextIcon.svg";
import { LANGUAGE_TABS, PollQuestionList } from "./view/question_lists";
import { RecipientsForm } from "./recipients/recipients";
import { CollaboratorForm } from "./recipients/collaborator";
import { Loader } from "@progress/kendo-react-indicators";
import { ReviewAndPublish } from "./review_publish/review_and_publish";
import BackIcon from "../../../assets/communication/Back.svg";
import RadioIcon from "../../../assets/poll_survey/radio.svg";
import CheckboxIcon from "../../../assets/poll_survey/checkbox.svg";
import StarIcon from "../../../assets/poll_survey/star.svg";
import NoDataIcon from "../../../assets/poll_survey/no_data.svg";

import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, Text, LabelList } from "recharts";
import TextAreaBox from "./components/text_area";
import { TextBox } from "@progress/kendo-react-inputs";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { Stepper } from "@progress/kendo-react-layout";
import { CustomStep } from "../../../components/common/custom_steps";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  allStatusConfig,
  ConfigDataForRecipient,
  statusConfig,
  statusConfigForApprove,
  statusConfigForPublishScheduled,
  statusConfigForPending
} from "./configData";
import { ShowFullScreenDialog } from "../../../components/reusableItems/fullscreen_dialog";
import * as XLSX from 'xlsx';
import { PollSurveyBarChartComponents } from "./components/barChart";
import { PollSurveyPieChartComponents } from "./components/pieChart";
import { PollSurveyDonutChartComponents } from "./components/donutChart";
import { PollSurveyStackedBarChartComponents } from "./components/stackBarChart";
import { PollSurveyNoRecord } from "./components/noRecord";

const SURVEY_TAB = {
  SURVEY_RESPONSE: "Survey Response",
  SURVEY_DETAIL: "Survey Detail",
};

export const DetailSurvey = () => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const { detail_loading, detail_data, summary_data, department_list, audit_data,
    audit_loading, department_list_loading } = useSelector(
      (state) => state.pollSurvey
    );

  const [surveyTab, setSurveyTab] = useState(SURVEY_TAB.SURVEY_DETAIL);
  const [tab, setTab] = useState(LANGUAGE_TABS.EN);
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [tempData, setTempData] = useState([]);
  const [status, setStatus] = useState("");
  const [recipientDialogTitle, setRecipientDialogTitle] = useState("");

  const [showUpdateStatus, setShowUpdateStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [tempStatusData, setTempStatusData] = useState([]);
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");

  const [tempId, setTempId] = useState("");
  const [tempDate, setTempDate] = useState("");
  const [timeChange, setTimeChange] = useState(false);
  const [showEndDateError, setShowEndDateError] = useState(false);
  const [showPublishDialog, setShowPublishDialog] = useState(false);


  const [showRecipientDialog, setShowRecipientDialog] = useState(false);

  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "survey.view_all_surveys"
  );

  const viewPermssionAsCollaborator = checkPermission(
    userPermissions,
    "survey.view_as_collaborator"
  );

  const checkUpdateStatus = checkPermission(
    userPermissions,
    "survey.publish_survey"
  );

  const checkUpdateStatusAsCollaborator = checkPermission(
    userPermissions,
    "survey.view_as_collaborator"
  );
  const checkClosedConcludedSurvey = detail_data.status !== "closed" && detail_data.status !== "concluded";
  const getData = async () => {

    dispatch(fetcheSurveyDetail(id)).then((res) => {
      const getstatus = allStatusConfig.find(status => status.id === res.payload.status);
      if (getstatus) {
        setStatus(getstatus.name);
      }

    });
    dispatch(fetchSurveyAudit(id));

    dispatch(fetcheSurveyDetailByDepartment(id)).then((res) => {

      if (Array.isArray(department_list) && department_list.length != 0) {
        setSelectedDepartment(res.payload[0].code);
        dispatch(fetcheSurveyDetailBySummary({ id: id, division: res.payload[0].code }));
      }

    });
  };

  const exportToXlsx = (data, fileName) => {
    console.log(data.en);
    console.log(data.zh);
    const wb = XLSX.utils.book_new(); // Create a new workbook
    // const ws = XLSX.utils.aoa_to_sheet(data.en); // Convert your array to a sheet
    const sheet1 = XLSX.utils.aoa_to_sheet(data.en);
    const sheet2 = XLSX.utils.aoa_to_sheet(data.zh);
    XLSX.utils.book_append_sheet(wb, sheet1, 'EN'); // Add sheet to workbook
    XLSX.utils.book_append_sheet(wb, sheet2, "ZH");
    XLSX.writeFile(wb, `${fileName}.xlsx`); // Save the file
  };


  const handleExport = () => {
    dispatch(fetchSurveyExport({ id: id, division: selectedDepartment })).then((res) => {
      exportToXlsx(res.payload, "Export_Poll_Survey");
    });

  }


  const onClickUpdateStatus = async () => {
    setTempDate(moment());

    const getStatus = allStatusConfig.find(status => status.id === detail_data.status);
    const currentIndex = statusConfig.findIndex(status => status.name === getStatus.name);

    const nextStatuses = currentIndex !== -1 ? statusConfig.slice(currentIndex + 1) : [];

    setTempStatusData(nextStatuses);

    if (getStatus.name == "Approved") {
      setTempStatusData(statusConfigForApprove);
    }
    if (getStatus.name == "Published" || getStatus.name == "Scheduled") {
      setTempStatusData(statusConfigForPublishScheduled)
    }
    if (getStatus.name == "Pending Approval") {
      setTempStatusData(statusConfigForPending);
    }
    setTempId(id);
    setTempStatus(getStatus.name);
    setTempStartDate(detail_data.publish_on);
    setTempEndDate(detail_data.publish_end);

    setShowUpdateStatus(true);
  }



  const updateStatus = () => {
    setTimeChange(false);
    setTempStartDate("");
    setShowPublishDialog(false);

    const getstatus = statusConfig.find(status => status.name === tempStatus);

    let params = { question_id: id, status: getstatus.id, updated_on: tempDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") };
    setTempId("");
    setTempStatus("");
    setShowUpdateStatus(false);
    dispatch(updatePollSurveyStatus(params)).then((res) => {
      if (res.payload.status_code === 200) {
        getData();
      } else {
        alert(res.payload.message);
      }
    });
  };

  const checkTimeForPublish = () => {
    setTempDate(moment());

    if (tempStatus == "Published") {
      const isPassed = moment().isAfter(moment(tempStartDate));

      if (isPassed) {
        setTimeChange(true);

      } else {
        setShowPublishDialog(true);
      }

    } else {
      updateStatus();
    }
  }

  const checkEndDateForPublish = () => {
    const isPassed = moment().isAfter(moment(tempEndDate));

    if (isPassed) {
      setShowEndDateError(true);
    } else {
      updateStatus();
    }
  }

  const getTime = () => {
    return tempDate.format('DD-MMM-YYYY hh:mm A');
  }



  const getSurveyDetailBySummary = async () => {
    dispatch(fetcheSurveyDetailBySummary({ id: id, division: selectedDepartment }));
  };

  useEffect(() => {
    getData();
  }, [id]);


  useEffect(() => {
    getSurveyDetailBySummary();
  }, [selectedDepartment]);




  const onTabChange = (tab) => {
    setTab(tab);
  };


  const onSurveyTabChange = (tab) => {
    setSurveyTab(tab);
  };


  // Custom color for the bars
  const getColor = (length, index) => {
    return "#FF6B6B"; // Using a fixed color (red) for simplicity
  };

  // Measure the width of the text dynamically to fit labels
  let ctx;

  const BAR_AXIS_SPACE = 10;

  // Custom Y-axis tick renderer
  const YAxisLeftTick = ({ y, payload: { value } }) => {
    return (
      <Text x={0} y={y} textAnchor="start" verticalAnchor="middle" fontSize={14} >
        {value}
      </Text>
    );
  };

  const WrappedYAxisTick = ({ x, y, payload }) => {
    const value = String(payload.value || ''); // Ensure it's a string, even if null/undefined
    const words = value.split(' ');

    return (
      <text x={x + 15} y={y} dy={4} textAnchor="end" fill="#666" fontSize="12">
        {words.map((word, index) => (
          <tspan x={x} dy={index === 0 ? 0 : 14} key={index}>
            {word}
          </tspan>
        ))}
      </text>
    );
  };


  // Chart Component
  const SummaryTypes = ({ question, qtype }) => {

    if (question && question.answers && question.answers.length > 0) {
      let config = {
        graph_title: question.qtitle,
        barSize: 40,
        legend_type: "text",
        for_module: "All",
        xAxis_type: "category",
        xAxis_key: "value",
        legend: true,
        config: question.answers.map(answer => ({
          color: answer.color,
          data_key: answer.value,
          title: `${answer.value}`,
          percent: `${answer.percent}%`
        }))
      }
      console.log(config);
      const barData = question.answers.map(answer => ({
        [answer.value]: answer.count,
        value: answer.value,
        percent: `${answer.percent}%`
      }));

      if (qtype == 'single-choice') {
        return <div className="poll_survey_chart">
          <PollSurveyPieChartComponents
            data={
              question &&
                question.answers &&
                question.answers.length > 0
                ? question.answers
                : []
            }
            config={config}
          />
        </div>
      } else if (qtype == 'multiple-choice') {
        return <div className="poll_survey_chart">
          <PollSurveyBarChartComponents
            data={
              question &&
                question.answers &&
                question.answers.length > 0
                ? barData
                : []
            }
            config={config}
          />
        </div>
      } else if (qtype == 'branching') {
        return <div className="poll_survey_chart">
          <PollSurveyDonutChartComponents
            data={
              question &&
                question.answers &&
                question.answers.length > 0
                ? question.answers
                : []
            }
            config={config}
          />
        </div>
      } else if (qtype == 'star-rating') {


        const result = question.answers.reduce((acc, item) => {
          acc[item.value] = item.count;
          return acc;
        }, {});
        console.log(config);
        



        return <PollSurveyStackedBarChartComponents
          data={
            question &&
              question.answers &&
              question.answers.length > 0
              ? [result]
              : []
          }
          config={config}
        />
      }
    }
    else {
      return <PollSurveyNoRecord />;
    }
  };


  const SummaryItem = ({ summary, index }) => {

    const data = summary.answers.map(answer => ({
      name: answer.value, // Option name
      count: answer.count,
      percent: `${answer.count}(${answer.percent}%)`,
    }));

    return (
      <div className="poll_and_survey_create_item_main_box">
        <div className="flex-between">
          <div className="poll_and_survey_create_item_main_box_title">{`Question ${index + 1}`}</div>
          <div className="required-text">{summary.is_required ? 'Required' : ''}</div>
        </div>
        <div className="poll_and_survey_create_item_main_box_field" style={{ margin: '1px' }}>
          {summary.qtype == "open-ended" ? (<div className="poll_and_survey_create_item_main_box_title">{summary.qtitle}</div>) : null}

          {summary.qtype != "open-ended" ? (
            <div>
              <SummaryTypes question={summary} qtype={summary.qtype} />
            </div>
          ) : null}

          <div>
            {summary.qtype == "open-ended" ? (
              summary.answers.map((answer, index) => (
                <div className="poll_and_survey_open_ended">
                  {answer.value}
                </div>
              ))
            ) : null}
          </div>

        </div>
      </div>
    );
  };

  const SurveyResponse = (() => {
    // Calculate the total count


    if (!Array.isArray(department_list) || department_list.length == 0) {
      return (<div></div>);
    }
    // const totalCount = department_list.reduce((sum, dept) => sum + dept.count, 0);
    // const totalCountTotal = department_list.reduce((sum, dept) => sum + dept.total, 0);

    // // Create the "All" object
    // const allDepartment = { value: "All", count: totalCount,total: totalCountTotal};
    // const temp_department = [allDepartment, ...department_list];


    return (
      <>
        <div>
          <div className="department-container-main">
            <div className="department-container">
              {department_list.map((department, index) => (
                <div
                  key={index}
                  className={`department-card ${selectedDepartment === department.code ? "selected-card" : ""}`}
                  onClick={() => {
                    setSelectedDepartment(department.code);
                  }
                  }
                >
                  {/* <img src={department.icon} className="department-icon" /> */}
                  <div className="department-count">{department.count}</div>
                  <div className="department-total">/ {department.total}</div>
                  <div className="department-name">{department.name}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="poll_and_survey_tab_content">
            <div className="tabs">
              <div
                onClick={() => onTabChange(LANGUAGE_TABS.EN)}
                className={`tab ${tab === LANGUAGE_TABS.EN ? "isactive" : ""
                  }`}
              >
                {LANGUAGE_TABS.EN}
              </div>
              <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
              <div
                onClick={() => onTabChange(LANGUAGE_TABS.CH)}
                className={`tab ${tab === LANGUAGE_TABS.CH ? "isactive" : ""
                  }`}
              >
                {LANGUAGE_TABS.CH}
              </div>
            </div>
          </div>



          <div className="poll_and_survey_items_list">
            {tab == LANGUAGE_TABS.EN ? (
              summary_data && summary_data?.answers_en?.length > 0
                ? summary_data.answers_en.map((summary, index) => (
                  <SummaryItem summary={summary} index={index} key={index} />
                ))
                : <div className="no-data">
                  <img src={NoDataIcon} />
                  <div> No Data</div>
                </div>
            ) : (
              summary_data && summary_data?.answers_zh?.length > 0
                ? summary_data.answers_zh.map((summary, index) => (
                  <SummaryItem summary={summary} index={index} key={index} />
                ))
                : <div className="no-data">
                  <img src={NoDataIcon} />
                  <div> No Data</div>
                </div>
            )

            }
          </div>


        </div>
      </>
    );

  });




  const RenderRow = ({ title, value }) => {
    return (
      <>
        {value ? (
          <>
            <div className="poll_survey_child_box_main_detail_items">
              <div className="poll_survey_child_box_main_detail_items_title poll_survey_center_item poll_survey_detail_padding_bottom">
                {title}
              </div>
              <div className="poll_survey_child_box_main_detail_items_splitter" />
              <div className="poll_survey_center_item poll_survey_child_box_main_detail_items_subdetail poll_survey_detail_padding_bottom">
                {value}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };



  const Item = ({ question, index }) => {

    return (
      <div className="poll_and_survey_create_item_main_box">
        <div className="flex-between">
          <div className="poll_and_survey_create_item_main_box_title">{`Question ${index + 1}`}</div>
          <div className="required-text" key={index}>{question.is_required ? 'Required' : ''}</div>
        </div>
        <div className="poll_and_survey_create_item_main_box_field" style={{ margin: "1px" }}>
          <div className="poll_and_survey_create_item_main_box_title">{`${question.qtitle}`}</div>
          {question.options.map((option, index) => (
            <div>
              <div className="poll-survey-option-item" style={{ marginBottom: "5px" }}>
                <img src={question.qtype === 'single-choice' ? RadioIcon : CheckboxIcon} className="delete-button-icon" />
                <div className="poll_and_survey_create_item_main_box_title_review">{`${option.value}`}</div>
              </div>
              {option.value.toLowerCase() === 'other' ?
                <div>
                  <TextBox
                    className="review-text-field"
                    value={"Please Input"}
                    disabled
                  />
                </div> : null}
            </div>
          ))}

          {question.qtype == "star-rating" ? (
            <div className="poll-survey-option-item" style={{ marginBottom: "5px" }}>
              <img src={StarIcon} className="delete-button-icon" />
              <img src={StarIcon} className="delete-button-icon" />
              <img src={StarIcon} className="delete-button-icon" />
              <img src={StarIcon} className="delete-button-icon" />
            </div>
          ) : null}

          {question.qtype == "open-ended" ? (
            <TextAreaBox
              className="review-text-field"
              value={"Please Input"}
              disabled={true}
            />
          ) : null}
        </div>
      </div>
    );
  }



  // Maximum number of names to show before "others"
  const MAX_DISPLAY_COUNT = 3;

  const CollaboratorView = ({ title, collaborators, onViewClick }) => {
    const displayNames = (collaborators || []).slice(0, MAX_DISPLAY_COUNT);
    const remainingNamesCount = collaborators.length - MAX_DISPLAY_COUNT;

    return (
      <div className="poll_survey_child_box_main_detail_items" key={title}>
        <div className="poll_survey_child_box_main_detail_items_title poll_survey_center_item poll_survey_detail_padding_bottom">
          {title}
        </div>
        <div className="poll_survey_child_box_main_detail_items_splitter" />
        <div className="poll_survey_center_item poll_survey_child_box_main_detail_items_subdetail poll_survey_detail_padding_bottom">
          <span>{displayNames.map((collaborator, index) => (
            <span key={collaborator.id}>
              {collaborator.name}
              {index < displayNames.length - 1 && ", "}
            </span>
          ))}</span>
          {/* {remainingNamesCount > 0 && (
            <span>
              , <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => onViewClick && onViewClick(title, collaborators)}>{`+${remainingNamesCount} others`}</span>
            </span>
          )} */}
          <span> , <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => onViewClick && onViewClick(title, collaborators)}>{`View`}</span>
          </span>
        </div>
      </div>

    );
  };


  const RecipientView = ({ title, collaborators, onViewClick }) => {
    const displayNames = (collaborators || []).slice(0, MAX_DISPLAY_COUNT);

    return (
      <div className="poll_survey_child_box_main_detail_items" key={title}>
        <div className="poll_survey_child_box_main_detail_items_title poll_survey_center_item poll_survey_detail_padding_bottom">
          {title}
        </div>
        <div className="poll_survey_child_box_main_detail_items_splitter" />
        <div className="poll_survey_center_item poll_survey_child_box_main_detail_items_subdetail poll_survey_detail_padding_bottom">
          <span >
            {`${collaborators?.length || 0} Recipients`}
          </span>
          <span><span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => onViewClick && onViewClick(title, collaborators)}>{`View`}</span>
          </span>
        </div>
      </div>

    );
  };


  const SurveyDetailView = (() => {

    return (
      <div className="">
        <div>

          <RenderRow
            title={"Title"}
            value={detail_data.title}
          />

          <RenderRow
            title={"Title in Description"}
            value={detail_data.description}
          />

          <RenderRow
            title={"Start Date"}
            value={detail_data.start_date}
          />

          <RenderRow
            title={"Start Time"}
            value={detail_data.start_time}
          />

          <RenderRow
            title={"End Date"}
            value={detail_data.end_date}
          />

          <RenderRow
            title={"End Time"}
            value={detail_data.end_time}
          />

          <RenderRow
            title={"Allow participants to view the survey after it is closed or concluded"}
            value={detail_data.user_visibility ? "True" : "False"}
          />

          <RecipientView
            title={"Distribution"}
            collaborators={detail_data.recipient}
            onViewClick={(title, collaborators) => {
              const cleanedData = collaborators.map(item => {
                const empSapTrimmed = String(item.emp_sap_no).replace(/^0+/, "");
                const idStr = String(item.id);
                return {
                  ...item,
                  id: empSapTrimmed === idStr ? "-" : item.id
                };
              });

              setTempData(cleanedData);

              setRecipientDialogTitle(title);
              setShowRecipientDialog(true);
            }}
          />

          <RecipientView
            title={"Collaborator"}
            collaborators={detail_data.collaborator}
            onViewClick={(title, collaborators) => {
              const cleanedData = collaborators.map(item => {
                const empSapTrimmed = String(item.emp_sap_no).replace(/^0+/, "");
                const idStr = String(item.id);
                return {
                  ...item,
                  id: empSapTrimmed === idStr ? "-" : item.id
                };
              });

              setTempData(cleanedData);

              setRecipientDialogTitle(title);
              setShowRecipientDialog(true);
            }}
          />

        </div>

        <div className="poll_and_survey_tab_content">
          <div className="tabs">
            <div
              onClick={() => onTabChange(LANGUAGE_TABS.EN)}
              className={`tab ${tab === LANGUAGE_TABS.EN ? "isactive" : ""
                }`}
            >
              {LANGUAGE_TABS.EN}
            </div>
            <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
            <div
              onClick={() => onTabChange(LANGUAGE_TABS.CH)}
              className={`tab ${tab === LANGUAGE_TABS.CH ? "isactive" : ""
                }`}
            >
              {LANGUAGE_TABS.CH}
            </div>
          </div>
        </div>


        {
          detail_data &&
            tab == LANGUAGE_TABS.EN ? (
            detail_data?.questions_en?.length > 0 ?
              detail_data.questions_en.map((question, index) => (
                <Item question={question} index={index} key={index} />
              ))

              : (
                <div className="no-data">
                  <img src={NoDataIcon} />
                  <div> No English Version</div>
                </div>
              )

          ) : (
            detail_data?.questions_zh?.length > 0 ?
              detail_data.questions_zh.map((question, index) => (
                <Item question={question} index={index} key={index} />
              ))
              : (
                <div className="no-data">
                  <img src={NoDataIcon} />
                  <div> No Chinese Version</div>
                </div>
              )
          )
        }


      </div>
    );
  });



  return (
    <>
      {viewPermssion || viewPermssionAsCollaborator ? (
        <div className="container">
          {showEndDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowEndDateError(false)}
            >
              <p>End Date cannot be earlier than Start Date!</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowEndDateError(false)
                    navigate(`${POLL_SURVEY_ADD}?id=${tempId}`);
                  }}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}

          {timeChange && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setTimeChange(false)}
            >
              <p>
                The selected publishing time has already passed. Could we proceed by
                submitting the new publish time for {getTime()}?
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTimeChange(false);
                    setTempStartDate("");
                  }}
                >
                  Go back
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => checkEndDateForPublish()}
                >
                  Submit
                </div>
              </div>
            </Dialog>
          )}


          {showPublishDialog && (
            <Dialog
              className="alert-form"
              title={"Manual Publish Confirmation"}
              width={400}
              // height={280}
              onClose={() => setShowPublishDialog(false)}
            >
              <p>
                You've configured a Start Date and Time for this Polls & Surveys.
                By manually publishing now, the Start Date and Time will be updated to the current time. The End Date and Time will remain unchanged.
              </p>
              <p>Do you want to continue?</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTimeChange(false);
                    setTempStartDate("");
                    setShowPublishDialog(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => updateStatus()}
                >
                  Publish Now
                </div>
              </div>
            </Dialog>
          )}

          {showUpdateStatus && (
            <ShowDialog
              cancelbtn={() => {
                setShowUpdateStatus(false);
                setTempStatus("");
              }}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={checkTimeForPublish}
              dropdownData={tempStatusData.map(status => status.name)}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          {showRecipientDialog && (
            <ShowFullScreenDialog
              cancelbtn={() => {
                setShowRecipientDialog(false);
                setTempData([]);
                setRecipientDialogTitle("");
              }}
              title={recipientDialogTitle}
              children={
                <>
                  <div className="poll_and_survey_scroll_box_detail" style={{ maxHeight: '500px' }}>

                    <Reusable_table
                      header={ConfigDataForRecipient}
                      data={tempData}
                      pagination={false}
                      calculatePagi={false}
                      pageChangeLoading={false}
                      showRow={true}
                      checkbox={false}
                    />
                  </div>
                </>
              }
            />
          )}


          {
            detail_loading || department_list_loading && (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100% - 75px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            )
          }
          <div className="poll_survey_child_box">

            <div className={surveyTab == SURVEY_TAB.SURVEY_RESPONSE ? "poll-survey-full-box" : "poll-survey-left-box"}>
              <div className="poll_and_survey_body">
                <div className="poll_and_survey_addheader" >
                  <div className="back-title-group" onClick={(e) => {
                    navigate(POLL_SURVEY_LIST);

                  }}>
                    <img src={BackIcon} className="back-icon" />
                    <span className="back-text">Back</span>
                  </div>
                </div>
              </div >

              <div className="poll_and_survey_scroll_box_detail">

                <div className="flex-between">
                  <div className="poll_and_survey_tab_content">
                    <div className="tabs">
                      <div
                        onClick={() => onSurveyTabChange(SURVEY_TAB.SURVEY_DETAIL)}
                        className={`tab ${surveyTab === SURVEY_TAB.SURVEY_DETAIL ? "isactive" : ""
                          }`}
                      >
                        {SURVEY_TAB.SURVEY_DETAIL}
                      </div>
                      <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                      <div
                        onClick={() => onSurveyTabChange(SURVEY_TAB.SURVEY_RESPONSE)}
                        className={`tab ${surveyTab === SURVEY_TAB.SURVEY_RESPONSE ? "isactive" : ""
                          }`}
                      >
                        {SURVEY_TAB.SURVEY_RESPONSE}
                      </div>

                    </div>

                  </div>
                  {surveyTab == SURVEY_TAB.SURVEY_RESPONSE ? (<div
                    className="poll-survey-export-btn"
                    onClick={() => {
                      handleExport();
                    }}

                  >
                    Download Excel
                  </div>)
                    : (detail_data.status == "draft" || detail_data.status == "pendingapproval" || detail_data.status == "scheduled") && (
                      <div
                        className="reusable_header_create_box"
                        onClick={() => {
                          navigate(`${POLL_SURVEY_ADD}?id=${id}`);
                        }}

                      >
                        Edit
                      </div>
                    )
                  }
                </div>



                <div className="poll_and_survey_items_list">
                  {surveyTab == SURVEY_TAB.SURVEY_RESPONSE ? (
                    <SurveyResponse />
                  ) : (
                    <SurveyDetailView />
                  )

                  }
                </div>
              </div>



            </div>

            <div className="poll_survey_right_box" hidden={surveyTab == SURVEY_TAB.SURVEY_RESPONSE ? true : false}>
              <div className="poll_survey_right_box_action_main_box">
                <div className="poll_survey_right_box_action_title">
                  Status
                </div>
                <div
                  className="poll_survey_right_box_action_delete"
                >
                  {status || ''}
                </div>
              </div>

              {(detail_data.status != 'draft' && detail_data.status != 'concluded' && detail_data.status != "closed") && (
                <div className="poll_survey_right_box_action_main_box">
                  <div className="poll_survey_right_box_action_title">
                    Actions
                  </div>
                  {(checkUpdateStatus || checkUpdateStatusAsCollaborator) && (checkClosedConcludedSurvey) && (
                    <div
                      className="poll_survey_right_box_action_edit"
                      onClick={() => onClickUpdateStatus()}
                    >
                      Update Status &#x2192;
                    </div>
                  )}
                </div>
              )

              }

              <div className="poll_survey_right_box_action_main_box">
                <div className="poll_survey_right_box_action_title">
                  Activity Trail
                </div>
                <div className={audit_data.length <= 1 && "audit_bar_hide"}>
                  {audit_loading ? (
                    <Loader
                      type="converging-spinner"
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#ffffff4d",
                      }}
                    />
                  ) : (
                    <Stepper
                      orientation={"vertical"}
                      items={audit_data}
                      item={CustomStep}
                    />
                  )}
                </div>
              </div>
            </div>

          </div>

        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}

    </>
  );
};
